import { BrowserRouter, Route, Routes } from "react-router-dom";
import "@/App.css";
import { LandingPage } from "@/components/landing/LandingPage";
import { AdminPage } from "@/components/admin/AdminPage";

function App() {
  return (
    <div className="app-shell">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
